import type {
  PuppyDisplayNodeBinding,
  PuppyDisplayNodeBodyBinding,
  PuppyVisibleModelExportDiagnostics,
} from './types'

/**
 * 创建初始诊断对象。
 *
 * @returns 诊断对象。
 */
export function createInitialDiagnostics(): PuppyVisibleModelExportDiagnostics {
  return {
    exportedMeshCount: 0,
    skippedInvisibleMeshCount: 0,
    skippedEmptyMeshCount: 0,
    skippedNonModelObjectCount: 0,
    missingBrepBindingMeshCount: 0,
    ambiguousBrepBindingMeshCount: 0,
    missingTopologySnapshotMeshCount: 0,
  }
}

/**
 * 创建离线包 display node 绑定。
 *
 * @param input 创建输入。
 * @returns display node 绑定。
 */
export function createDisplayNodeBinding(input: {
  /** display node ID。*/
  displayNodeId: string
  /** 当前 display node 所属的稳定装配节点 ID。 */
  assemblyNodeId?: string
  /** GLB 节点名称。*/
  nodeName: string
  /** body 绑定列表。*/
  bodyBindings: PuppyDisplayNodeBodyBinding[]
}): PuppyDisplayNodeBinding {
  const geometryObjectIds = Array.from(new Set(
    input.bodyBindings.map((binding) => binding.geometryObjectId),
  ))
  return {
    displayNodeId: input.displayNodeId,
    ...(input.assemblyNodeId ? { assemblyNodeId: input.assemblyNodeId } : {}),
    nodeName: input.nodeName,
    geometryObjectIds,
    bodyBindings: input.bodyBindings,
  }
}
